var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.ifBK?'wrap':'',_vm.ifsquare?'xxx_c':'']},[_vm._t("v"),_c('div',{class:[_vm.ifsquare?'square1':'']}),_c('div',{class:[_vm.ifsquare?'square2':'']})],2)}
var staticRenderFns = []

export { render, staticRenderFns }